import request from '../utils/request'

export function invocer() {
    return request({
        url: 'dashboard/invoicer',
        method: 'get'
    })
}

export function savedRequest(data) {
    return request({
        url: 'dashboard/save/invoicer',
        method: 'post',
        data
    })
}

export function updateRequest(data) {
    return request({
        url: 'dashboard/update/invoicer',
        method: 'post',
        data
    })
}
